import {
  applyContextOptions,
  restoreContextOptions,
} from "@gameApp/helpers/canvas/contextOptions";
import {
  applyTranslate,
  restoreTranslate,
} from "@gameApp/helpers/canvas/translate";
import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";

interface DrawLineOptions extends BasicDrawOptions {
  startXY: [number, number];
  endXY: [number, number];
}

export function drawLine(options: DrawLineOptions): void {
  const { context, startXY = [0, 0], endXY = [0, 0] } = options;
  applyTranslate(options);
  applyContextOptions(options);
  context.save();
  context.beginPath();
  context.moveTo(...startXY);
  context.lineTo(...endXY);
  context.stroke();
  context.closePath();
  context.restore();
  restoreContextOptions(options);
  restoreTranslate(options);
}
